class Harm {
  constructor(wrapEl) {
    this.wrapEl = wrapEl
    this.list = wrapEl.querySelectorAll('.harm__item')
  }

  // Finds elements matching selector that belong to item directly,
  // i.e. not inside a nested harm__item child.
  findOwn(item, selector) {
    return Array.from(item.querySelectorAll(selector)).filter(
      el => el.closest('.harm__item') === item
    )
  }

  calcHeight(list) {
    let res = 0
    for(let count = 0; count < list.length; count++) {
      res += list[count].offsetHeight
    }
    return res
  }

  isOpened(item) {
    return item.classList.contains('opened')
  }

  onClick(event) {
    const head = event.currentTarget
    const item = head.closest('.harm__item')
    const body = this.findOwn(item, '.harm__body')[0]

    const openedSibling = Array.from(item.parentElement.children).find(
      el => el !== item && el.classList.contains('harm__item') && el.classList.contains('opened')
    )
    if (openedSibling) {
      const openedHead = this.findOwn(openedSibling, '.harm__head, .harm__btn')[0]
      if (openedHead) openedHead.click()
    }

    item.classList.toggle('opened')

    const isOpened = this.isOpened(item)

    if (isOpened) {
      const height = this.calcHeight(body.children)

      body.style.height = `${height}px`
      body.addEventListener('transitionend', () => {
        if (body.style.height) {
          body.style.height = 'auto'
        }
      }, { once: true })
    } else {
      const height = this.calcHeight(body.children)

      body.style.height = `${height}px`

      setTimeout(() => {
        body.removeAttribute('style')
      }, 0)
    }
  }

  init() {
    this.list.forEach(item => {
      const toggleBtns = this.findOwn(item, '.harm__head, .harm__btn')

      toggleBtns.forEach(btn => {
        btn.addEventListener('click', this.onClick.bind(this))
      })
    })
  }
}

const harmNodes = document.querySelectorAll('.harm')

harmNodes.forEach(item => {
  const harm = new Harm(item)
  harm.init()
})